import React from 'react';

const Legal = ({ title, lastUpdated, children }) => {
    return (
        <div style={styles.container}>
            <h1 style={styles.title}>{title}</h1>
            <p style={styles.subtitle}>Last Updated: {lastUpdated}</p>
            <div style={styles.content}>
                {children || <p>Policy content goes here...</p>}
            </div>
        </div>
    );
};

const styles = {
    container: { maxWidth: '800px', margin: '0 auto', padding: '80px 20px' },
    title: { fontSize: '32px', color: '#2f3e46', marginBottom: '10px' },
    subtitle: { color: '#999', fontSize: '14px', marginBottom: '40px' },
    content: { lineHeight: '1.8', color: '#555' }
};

export default Legal;
